import request from '@/utils/request'

let Ma_labor_protectionApi = {

  /*劳保列表*/
  list(data) {
    return request._post('/shop/plus.ma_labor_protection.Index/index', data);
},
/*添加劳保*/
add(data) {
    return request._post('/shop/plus.ma_labor_protection.Index/add', data);
},
/*修改劳保*/
edit(data) {
    return request._post('/shop/plus.ma_labor_protection.Index/edit', data);
},
/*删除劳保*/
del(data) {
    return request._post('/shop/plus.ma_labor_protection.Index/del', data);
},
/*劳保详情*/
detail(data) {
  return request._post('/shop/plus.ma_labor_protection.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ma_labor_protection.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ma_labor_protection.Setting/getSetting', data, errorback);
    },

    importData(data) {
        return request._post('/shop/plus.ma_labor_protection.Index/import', data);
    },
    exportExcel(data) {
        return request._post('/shop/plus.ma_labor_protection.Index/export', data);
    },
}
export default Ma_labor_protectionApi;



// WEBPACK FOOTER //
// ./src/api/ma_labor_protection.js